import { render, staticRenderFns } from "./AudioInput.vue?vue&type=template&id=705cbdf8&scoped=true"
import script from "./AudioInput.vue?vue&type=script&lang=js"
export * from "./AudioInput.vue?vue&type=script&lang=js"
import style0 from "./AudioInput.vue?vue&type=style&index=0&id=705cbdf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705cbdf8",
  null
  
)

export default component.exports